import { useState } from "react";
import { useNavigate } from "react-router-dom";
import HeaderInbox from "@/components/HeaderInbox";
import { useCart } from "@/context/CartContext";
import { IconMenu, IconFaq, IconCart, IconSwords } from "@/components/HeaderIcons";
import LanguagePicker from "@/components/LanguagePicker";

export default function HeaderMenu({ showFaq }) {
  const [open, setOpen] = useState(false);
  const [alerts, setAlerts] = useState(0);
  const navigate = useNavigate();
  const { count, setOpen: setCartOpen } = useCart();
  const close = () => setOpen(false);
  return (
    <div className="relative">
      <button data-testid="header-menu-btn" onClick={() => setOpen((o) => !o)} title="Menu"
        className="hdr-icon relative w-10 h-10 flex items-center justify-center">
        <IconMenu size={26} />
        {alerts > 0 && (
          <span data-testid="header-menu-alert-badge"
            className="absolute -top-1 -right-1 bg-pb-red text-black text-[10px] font-black px-1.5 py-0.5 min-w-[18px] text-center leading-none shadow-[0_0_8px_rgba(239,68,68,0.7)]">
            {alerts > 99 ? "99+" : alerts}
          </span>
        )}
      </button>
      {open && <div className="fixed inset-0 z-[60]" onClick={close} />}
      <div className={`absolute right-0 top-12 z-[65] w-60 bg-black/95 backdrop-blur-md border border-[#A3E635]/30 shadow-[0_12px_40px_rgba(0,0,0,.75)] p-1.5 ${open ? "animate-fade-up" : "hidden"}`}
        data-testid="header-menu-dropdown">
        <HeaderInbox variant="menu" onAction={close} onCounts={setAlerts} />
        <button data-testid="header-cardwars-btn" onClick={() => { close(); navigate("/card-wars"); }} className="hm-item">
          <IconSwords size={24} /> <span className="text-yellow-400">Card Wars</span>
        </button>
        <button data-testid="global-cart-btn" onClick={() => { close(); setCartOpen(true); }} className="hm-item">
          <span className="relative inline-flex">
            <IconCart size={24} />
            {count > 0 && (
              <span data-testid="cart-count-badge"
                className="absolute -top-1.5 -right-1.5 bg-pb-red text-black text-[10px] font-black px-1.5 py-0.5 min-w-[18px] text-center leading-none">{count}</span>
            )}
          </span>
          <span>Cart{count > 0 ? ` · ${count}` : ""}</span>
        </button>
        {showFaq && (
          <button data-testid="faq-btn" onClick={() => { close(); navigate("/faq"); }} className="hm-item">
            <IconFaq size={24} /> <span>FAQ</span>
          </button>
        )}
        <LanguagePicker onDone={close} />
      </div>
    </div>
  );
}
